var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{attrs:{"auto-grow":"","dense":"","outlined":"","rows":"1","label":_vm.$t('common.answer'),"resize":false,"value":_vm.response,"disabled":_vm.loading,"rules":_vm.rules},on:{"input":function($event){return _vm.$emit('change', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }